import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { SiteProvider } from "./context/SiteContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import FlowBackground from "./components/FlowBackground";
import PromoPopup from "./components/PromoPopup";
import ChatButton from "./components/ChatButton";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import Track from "./pages/Track";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";

const StoreLayout = () => (
  <>
    <FlowBackground />
    <div className="flow-content">
      <Header />
      <CartDrawer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/track" element={<Track />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
    <PromoPopup />
    <ChatButton />
  </>
);

function App() {
  return (
    <div className="App bg-navy min-h-screen">
      <BrowserRouter>
        <SiteProvider>
          <CartProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/*" element={<StoreLayout />} />
            </Routes>
            <Toaster />
          </CartProvider>
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
